<template>
    <div>
        <resource-card :resource="resource" :can-edit="true" />

        <div class="card">
            <div class="card-header">
                <p class="card-header-title">
                    Content Preview
                </p>
            </div>
            <div class="card-content content" v-html="resource.content"></div>
        </div>
    </div>
</template>

<script>
import axios from 'axios';
import _ from 'lodash';
import BoxResourceTransformer from '../BoxResourceTransformer';
import ResourceCard from './ResourceCard';

export default {
    props: {
        boxId: {
            type: Number,
            default: null
        }
    },

    data() {
        return {
            resource: {}
        };
    },

    components: {
        'resource-card': ResourceCard
    },

    created() {
        // TO DO - get current user role and enable edit as required

        if (window.AR && window.AR.data && window.AR.data.resource) {
            // Grab bootstrapped data from the global namespace
            this.resource = BoxResourceTransformer(window.AR.data.resource);
        } else {
            // TODO - Fetch the data
        }
    }
}
</script>



// WEBPACK FOOTER //
// resources/assets/js/components/LibrarySingle.vue